/**
 * Class name to be added to elements that are safe to interact with in an opened Popover/Dialog
 * This is used to prevent the popup from closing when interacting with elements outside the popup
 */
export const popupSafeClassName = 'popup-safe-element';

/**
 * Handler to check whether the element is inside the DOM tree part that is safe to interact
 * without affecting (e.g. closing) opened Popover/Dialog
 */
export const isPopupSafeElement = (element: EventTarget | null): boolean => {
  while (element instanceof Element) {
    if (element.classList.contains(popupSafeClassName)) {
      return true;
    }

    element = element.parentElement;
  }

  return false;
};
